import { render, staticRenderFns } from "./active5.vue?vue&type=template&id=3a67fcd6&scoped=true"
import script from "./active5.vue?vue&type=script&lang=js"
export * from "./active5.vue?vue&type=script&lang=js"
import style0 from "./active5.vue?vue&type=style&index=0&id=3a67fcd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67fcd6",
  null
  
)

export default component.exports